export default __webpack_public_path__ + "static/media/bg_2.d74cae34.jpeg";